export default __webpack_public_path__ + "static/media/DeviceGroupColor.e7d264b2.svg";